import TextField from 'Shared/components/TextField'
import useAnswerTranslate from 'FlowBuilder/hooks/useAnswerTranslate'
import { answerTranslatables } from 'FlowBuilder/lib/questionTranslatable'
import { useLanguagesData } from 'FlowBuilder/hooks/useLanguageFlow'
import './TranslationSettings.scoped.scss'
import TranslatableHtmlField from './TranslatableHtmlField'
import { useAct } from 'FlowBuilder/store'

export default function AnswerTranslateSettings({ questionName, answerId }) {
  const answer = useSel(s => s.answers.entities[answerId])

  if (answer) {
    return <>
      {Object.keys(answerTranslatables).map((strKey) => (
        <AnswerTranslateSetting questionName={questionName} answer={answer} translatable={answerTranslatables[strKey]} strKey={strKey} key={strKey} />
      ))}
    </>
  }

  return <></>
}

function AnswerTranslateSetting({ questionName, answer, strKey, translatable }) {
  const { editableLanguagesData } = useLanguagesData()

  return <>
    <div className="translatable-label">
      <span><strong>{questionName}</strong></span>
      <span>{translatable.label} - { answer.answer }</span>
    </div>
    {Object.keys(editableLanguagesData).map((lang) => (
      <AnswerTranslateLanguageSetting
        key={lang}
        answer={answer}
        strKey={strKey}
        key={strKey}
        translatable={translatable}
        languageOverride={lang}
      />
    ))}
  </>
}

function AnswerTranslateLanguageSetting({ answer, strKey, translatable, languageOverride }) {
  const act = useAct()
  const {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag,
  } = useAnswerTranslate({ answerId: answer.id, languageOverride: languageOverride })

  function openHtmlEditor() {
    act.local.setModal({
      kind: 'editContent',
      fieldKind: 'answerTextContent',
      answerId: answer.id,
      slug: strKey,
      wysiwyg: true,
      language: languageOverride,
    })
  }

  return <div className={`translatable-input translatable-input-${languageOverride} translatable-input-${strKey} translatable-input-${answer.id}`}>
    <span>{flag}</span>
    {translatable.html ? (
      <TranslatableHtmlField
        value={translated[strKey] || ''}
        placeholder={fallback[strKey] || translatable.default || answer.answer}
        onClick={openHtmlEditor}
      />
    ) : (
      <TextField
        key={strKey + answer.id + languageOverride}
        value={translated[strKey] || ''}
        placeholder={fallback[strKey] || translatable.default || answer.answer}
        onChange={(val) => textContentUpdater(strKey, val)}
      />
    )}
  </div>
}
